enum ModalTypeEnums {
	PAGE_ONE_CHOICE,
	PAGE_TWO_LIST,
}

export { ModalTypeEnums };
